<button id="btnAlertDialog{{id}}" type="button" class="btn btn-info btn-lg" (click)="showErrorDialog(errorDialog)"
    [hidden]="true">Show Dialog</button>
<ng-template #errorDialog let-modal id="modlErrorPopUp">
    <div class="modal-header">
        <div><ng-content select=".header"></ng-content></div>
        <img src="assets/images/close_icon.svg" style="width:20px; height:20px; cursor:pointer" alt
            (click)="okClicked();modal.dismiss('Cross click')" />
    </div>
    <div class="modal-body">
        @if(!type || type == 'Error'){
        <p class="text-center" >
            <img src="../../../assets/images/alert_red_large.svg" alt="" />
        </p>
    }
        <p class="text-center mt-2"><ng-content select=".message"></ng-content></p>
        <div class="form-group mb-2">
            <div class="action-btn d-flex justify-content-center mt-2">
                <div><button class="submitButton mr-0" (click)="okClicked();modal.dismiss('Cross click');">OK</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>